import React from 'react';

export const homelessLabel = (
  <p>
    I’m <strong>currently</strong> homeless.
  </p>
);

export const homelessConfirmationLabel = <div>I am currently homeless.</div>;

export const atRiskLabel = (
  <p>
    I’m <strong>at risk</strong> of becoming homeless.
  </p>
);
export const atRiskConfirmationLabel = (
  <div>I am at risk of becoming homeless.</div>
);
